var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "confirmationReviewModal",
        "aria-hidden": "true",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _vm._m(0),
              _vm._m(1),
              _c(
                "div",
                {
                  staticClass: "modal-footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: {
                        "data-dismiss": "modal",
                        type: "button",
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.discardChanges()
                        },
                      },
                    },
                    [_vm._v(" Discard changes ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-header",
      },
      [
        _c(
          "h5",
          {
            staticClass: "modal-title",
            attrs: {
              id: "exampleModalLabel",
            },
          },
          [
            _vm._v(" Are you sure you want to leave the page? "),
            _c("span", [_vm._v(" You have unsaved changes. ")]),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              "aria-label": "Close",
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [
            _c(
              "span",
              {
                attrs: {
                  "aria-hidden": "true",
                },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-body",
      },
      [
        _c("p", [
          _vm._v("Discard your changes, or cancel to continue editing."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }